import { create } from "zustand";
import api from "../../../../api/axios";
import { message } from "antd";

export const useSingleService = create((set, get) => ({
    // === STATE ===
    loading: false,
    service: null,
    images: [],
    specificFields: [],
    specificData: [],
    halls: [],
    songs: [],
    warehouse: [],
    warehouseItems: [],
    warehouseCategories: [],
    warehouseWriteoffs: [],
    orders: [],
    comments: [],
    employees: [],
    serviceTariffs: [],
    foodsList: [],

    // === LOAD ALL ===
    loadService: (id) => {
        set({ loading: true });
        api.get(`/services/${id}`).then(res => {
            set({ service: res.data.data || res.data });
        }).catch(err => {
            console.error(err);
            message.error("Xizmat ma'lumotini yuklashda xatolik");
        }).finally(() => set({ loading: false }));
    },

    // === SERVICE INFO ===
    updateService: (id, data) => {
        return api.put(`/services/${id}`, data).then(res => {
            set({ service: res.data.data || res.data });
            message.success("Xizmat yangilandi");
        }).catch(err => {
            console.error(err);
            message.error("Yangilashda xatolik");
        });
    },

    // === SERVICE IMAGES ===
    getImages: (serviceId) => {
        api.get(`services/${serviceId}/images`).then(res => {
            set({ images: res.data.data || res.data || [] });
        }).catch(err => console.error(err));
    },
    addImage: (serviceId, data) => {
        // `file_path`, `file_size`, `file_type`

        // file_path file_size  file_type

        let reqdata = {
            file_path: data.file_path,
            file_size: data.file_size,
            file_type: data.file_type,
            services_id: serviceId
        }
        
        return api.post(`services/${serviceId}/images`, reqdata).then(res => {
            get().getImages(serviceId);
            message.success("Rasm qo'shildi");
        }).catch(err => {
            console.error(err);
            message.error("Rasm qo'shishda xatolik");
        });
    },
    deleteImage: (id, serviceId) => {
        return api.delete(`services/${id}/images`).then(() => {
            if (serviceId) {
                get().getImages(serviceId);
            } else {
                set(s => ({ images: s.images.filter(i => i.id !== id) }));
            }
            message.success("Rasm o'chirildi");
        }).catch(err => {
            console.error(err);
            message.error("O'chirishda xatolik");
        });
    },

    // === SPECIFIC DATA ===
    getSpecificFields: (serviceId) => {
        api.get(`/specific-fields/${serviceId}`).then(res => {
            set({ specificFields: res.data.data || res.data || [] });
        }).catch(err => console.error(err));
    },
    addSpecificData: (data, sid, key) => {
        data.key = key
        data.services_id = sid
        return api.post('/specific-data/' + sid, data).then(() => {
            get().getSpecificData(data.services_id);
            message.success("Ma'lumot qo'shildi");
        }).catch(err => {
            console.error(err);
            message.error("Qo'shishda xatolik");
        });
    },
    getSpecificData: (sid) => {
         api.get(`/specific-data/${sid}`).then(res => {
            set({ specificData: res.data.data || res.data || [] });
        }).catch(err => console.error(err));
    },

    // === HALLS ===
    getHalls: (serviceId) => {
        api.get(`/services/${serviceId}/halls`).then(res => {
            set({ halls: res.data.data || res.data || [] });
        }).catch(err => console.error(err));
    },
    addHall: (data) => {
        return api.post('/halls', data).then(() => {
            get().getHalls(data.services_id);
            message.success("Zal qo'shildi");
        }).catch(err => {
            console.error(err);
            message.error("Qo'shishda xatolik");
        });
    },
    updateHall: (id, data) => {
        return api.put(`/halls/${id}`, data).then(() => {
            get().getHalls(data.services_id);
            message.success("Zal yangilandi");
        }).catch(err => {
            console.error(err);
            message.error("Yangilashda xatolik");
        });
    },
    deleteHall: (id, serviceId) => {
        return api.delete(`/halls/${id}`).then(() => {
            set(s => ({ halls: s.halls.filter(i => i.id !== id) }));
            message.success("Zal o'chirildi");
        }).catch(err => {
            console.error(err);
            message.error("O'chirishda xatolik");
        });
    },


    // === TARIFS ===

    addTarif: (data, serviceId) => {
        return api.post(`/halls/${data.halls_id}/event-types`, data).then(() => {
            get().getHalls(serviceId);
            message.success("Tarif qo'shildi");
        }).catch(err => {
            console.error(err);
            message.error("Qo'shishda xatolik");
        });
    },
    deleteTarif: (id, serviceId) => {
        return api.delete(`/halls/${id}/event-types`).then(() => {
            get().getHalls(serviceId);
            message.success("Tarif o'chirildi");
        }).catch(err => {
            console.error(err);
            message.error("O'chirishda xatolik");
        });
    },




    // === SERVICE TARIFFS (taom + zal paketi) ===
    getServiceTariffs: (serviceId) => {
        api.get(`/service-tariffs/service/${serviceId}`).then(res => {
            set({ serviceTariffs: res.data.data || [] });
        }).catch(err => console.error(err));
    },
    getFoodsList: () => {
        api.get('/foods').then(res => {
            set({ foodsList: res.data.data || [] });
        }).catch(err => console.error(err));
    },
    addServiceTariff: (data) => {
        return api.post('/service-tariffs', data).then(() => {
            get().getServiceTariffs(data.services_id);
            message.success("Tarif qo'shildi");
        }).catch(err => {
            console.error(err);
            message.error(err.response?.data?.message || "Qo'shishda xatolik");
            throw err;
        });
    },
    updateServiceTariff: (id, data) => {
        return api.put(`/service-tariffs/${id}`, data).then(() => {
            get().getServiceTariffs(data.services_id);
            message.success("Tarif yangilandi");
        }).catch(err => {
            console.error(err);
            message.error(err.response?.data?.message || "Yangilashda xatolik");
            throw err;
        });
    },
    deleteServiceTariff: (id, serviceId) => {
        return api.delete(`/service-tariffs/${id}`).then(() => {
            set(s => ({ serviceTariffs: s.serviceTariffs.filter(i => i.id !== id) }));
            message.success("Tarif o'chirildi");
        }).catch(err => {
            console.error(err);
            message.error("O'chirishda xatolik");
        });
    },

    // === SONGS ===
    getSongs: (serviceId) => {
        api.get(`/songs/${serviceId}/service`).then(res => {
            set({ songs: res.data.data || res.data || [] });
        }).catch(err => console.error(err));
    },
    addSong: (data) => {
        return api.post('/songs', data).then(() => {
            get().getSongs(data.services_id);
            message.success("Qo'shiq qo'shildi");
        }).catch(err => {
            console.error(err);
            message.error("Qo'shishda xatolik");
        });
    },
    updateSong: (id, data) => {
        return api.put(`/songs/${id}`, data).then(() => {
            get().getSongs(data.services_id);
            message.success("Qo'shiq yangilandi");
        }).catch(err => {
            console.error(err);
            message.error("Yangilashda xatolik");
        });
    },
    deleteSong: (id, serviceId) => {
        return api.delete(`/songs/${id}`).then(() => {
            set(s => ({ songs: s.songs.filter(i => i.id !== id) }));
            message.success("Qo'shiq o'chirildi");
        }).catch(err => {
            console.error(err);
            message.error("O'chirishda xatolik");
        });
    },

    // === WAREHOUSE ===
    getWarehouse: (serviceId) => {
        api.get(`/warehouse/${serviceId}`).then(res => {
            set({ warehouse: res.data.data || res.data || [] });
        }).catch(err => console.error(err));
    },
    addWarehouse: (data) => {
        return api.post('/warehouse', data).then(() => {
            get().getWarehouse(data.services_id);
            message.success("Ombor qo'shildi");
        }).catch(err => {
            console.error(err);
            message.error("Qo'shishda xatolik");
        });
    },
    updateWarehouse: (id, data) => {
        return api.put(`/warehouse/${id}`, data).then(() => {
            get().getWarehouse(data.services_id);
            message.success("Ombor yangilandi");
        }).catch(err => {
            console.error(err);
            message.error("Yangilashda xatolik");
        });
    },
    deleteWarehouse: (id, serviceId) => {
        return api.delete(`/warehouse/${id}`).then(() => {
            set(s => ({ warehouse: s.warehouse.filter(i => i.id !== id) }));
            message.success("Ombor o'chirildi");
        }).catch(err => {
            console.error(err);
            message.error("O'chirishda xatolik");
        });
    },

    // === WAREHOUSE CATEGORIES ===
    getWarehouseCategories: (warehouseId) => {
        api.get(`/warehouse/${warehouseId}/categories`).then(res => {
            set({ warehouseCategories: res.data.data || [] });
        }).catch(err => console.error(err));
    },
    addWarehouseCategory: (warehouseId, data) => {
        return api.post(`/warehouse/${warehouseId}/categories`, data).then(() => {
            get().getWarehouseCategories(warehouseId);
            message.success("Kategoriya qo'shildi");
        }).catch(err => {
            console.error(err);
            message.error("Qo'shishda xatolik");
        });
    },
    updateWarehouseCategory: (warehouseId, catId, data) => {
        return api.put(`/warehouse/${warehouseId}/categories/${catId}`, data).then(() => {
            get().getWarehouseCategories(warehouseId);
            message.success("Kategoriya yangilandi");
        }).catch(err => {
            console.error(err);
            message.error("Yangilashda xatolik");
        });
    },
    deleteWarehouseCategory: (warehouseId, catId) => {
        return api.delete(`/warehouse/${warehouseId}/categories/${catId}`).then(() => {
            get().getWarehouseCategories(warehouseId);
            get().getWarehouseItems(warehouseId);
            message.success("Kategoriya o'chirildi");
        }).catch(err => {
            console.error(err);
            message.error("O'chirishda xatolik");
        });
    },

    // === WAREHOUSE ITEMS ===
    getWarehouseItems: (warehouseId) => {
        api.get(`/warehouse/${warehouseId}/items`).then(res => {
            set({ warehouseItems: res.data.data || [] });
        }).catch(err => console.error(err));
    },
    addWarehouseItem: (warehouseId, data) => {
        return api.post(`/warehouse/${warehouseId}/items`, data).then(() => {
            get().getWarehouseItems(warehouseId);
            message.success("Mahsulot qo'shildi");
        }).catch(err => {
            console.error(err);
            message.error("Qo'shishda xatolik");
        });
    },
    updateWarehouseItem: (warehouseId, itemId, data) => {
        return api.put(`/warehouse/${warehouseId}/items/${itemId}`, data).then(() => {
            get().getWarehouseItems(warehouseId);
            message.success("Mahsulot yangilandi");
        }).catch(err => {
            console.error(err);
            message.error("Yangilashda xatolik");
        });
    },
    deleteWarehouseItem: (warehouseId, itemId) => {
        return api.delete(`/warehouse/${warehouseId}/items/${itemId}`).then(() => {
            get().getWarehouseItems(warehouseId);
            message.success("Mahsulot o'chirildi");
        }).catch(err => {
            console.error(err);
            message.error("O'chirishda xatolik");
        });
    },

    // === WAREHOUSE WRITEOFFS (SPISANIE) ===
    getWarehouseWriteoffs: (warehouseId) => {
        api.get(`/warehouse/${warehouseId}/writeoffs`).then(res => {
            set({ warehouseWriteoffs: res.data.data || [] });
        }).catch(err => console.error(err));
    },
    writeoffItem: (warehouseId, data) => {
        return api.post(`/warehouse/${warehouseId}/writeoff`, data).then(() => {
            get().getWarehouseItems(warehouseId);
            get().getWarehouseWriteoffs(warehouseId);
            message.success("Mahsulot spisat qilindi");
        }).catch(err => {
            console.error(err);
            const msg = err.response?.data?.message || "Spisat qilishda xatolik";
            message.error(msg);
            throw err;
        });
    },

    // === ORDERS ===
    getOrders: (serviceId) => {
        api.get(`/orders/service/${serviceId}`).then(res => {
            set({ orders: res.data.data || res.data || [] });
        }).catch(err => console.error(err));
    },

    // === COMMENTS ===
    getComments: (serviceId) => {
        api.get(`/comments/service/${serviceId}`).then(res => {
            set({ comments: res.data.data || res.data || [] });
        }).catch(err => console.error(err));
    },
    deleteComment: (id, serviceId) => {
        return api.delete(`/comments/${id}`).then(() => {
            set(s => ({ comments: s.comments.filter(i => i.id !== id) }));
            message.success("Izoh o'chirildi");
        }).catch(err => {
            console.error(err);
            message.error("O'chirishda xatolik");
        });
    },

    // === EMPLOYEES ===
    getEmployees: (serviceId) => {
        api.get(`/employees/service/${serviceId}`).then(res => {
            set({ employees: res.data.data || res.data || [] });
        }).catch(err => console.error(err));
    },

    // === RESET ===
    reset: () => set({
        service: null, images: [], specificData: [], halls: [], warehouseItems: [], warehouseCategories: [], warehouseWriteoffs: [],
        songs: [], warehouse: [], orders: [], comments: [], employees: [],
        loading: false,
    }),
}));
